import BaseAction from "../base_action";
import { GET_PLAN_CHANGE_LOGS } from '../../constants'

export default class LibraryControlAction extends BaseAction {

  getPlanChangeLogs = (params) => {
    const actionTypes  = GET_PLAN_CHANGE_LOGS;
    const url = `/__api/v1/plans/${params.plan_id}/change_logs`;
    return this.apiGet(actionTypes, url, { params: params });
  }
}


// WEBPACK FOOTER //
// ./src/actions/v2/plan.js